<div class="discussion-page">
  <app-header></app-header>

  <div class="discussion-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <div class="discussion-page--main">
      <div class="discussion-page--container">
        <aside class="discussion-page--sidebar">
          <button 
            class="discussion-page--new-discussion-btn"
            type="button"
            (click)="createNewDiscussion()"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            New Discussion
          </button>
          <app-discussion-sidebar [activeTab]="activeTab"></app-discussion-sidebar>
        </aside>

        <main class="discussion-page--main-content">
          <div class="discussion-content">
            <div class="discussion-content--header">
              <div class="discussion-content--title-wrapper">
                <div class="discussion-content--title-row">
                  <h2 class="discussion-content--title">Post Submission</h2>
                </div>
                <p class="discussion-content--description">
                  Track the status of your submitted discussions. View pending, approved, and rejected submissions.
                </p>
              </div>
            </div>

            <!-- Status Tabs: All, Pending, Approved, Rejected, Feedback -->
            <div class="post-submission--tabs-wrapper">
              <div class="post-submission--tabs">
                <button
                  class="post-submission--tab"
                  [class.active]="statusTab === 'all'"
                  (click)="setStatusTab('all')"
                  type="button"
                >
                  All
                </button>
                <button
                  class="post-submission--tab"
                  [class.active]="statusTab === 'pending'"
                  (click)="setStatusTab('pending')"
                  type="button"
                >
                  Pending
                </button>
                <button
                  class="post-submission--tab"
                  [class.active]="statusTab === 'approved'"
                  (click)="setStatusTab('approved')"
                  type="button"
                >
                  Approved
                </button>
                <button
                  class="post-submission--tab"
                  [class.active]="statusTab === 'rejected'"
                  (click)="setStatusTab('rejected')"
                  type="button"
                >
                  Rejected
                </button>
                <button
                  class="post-submission--tab"
                  [class.active]="statusTab === 'changes-required'"
                  (click)="setStatusTab('changes-required')"
                  type="button"
                >
                  Feedback (by Admin)
                </button>
              </div>
            </div>

            <app-discussion-list
              [discussions]="discussions"
              [isLoggedIn]="isLoggedIn"
              [categoryName]="'Post Submission'"
              [showDeleteForOwner]="true"
              [showEditOnlyForChangesRequired]="true"
              [hideStatusBadge]="statusTab === 'pending' || statusTab === 'approved' || statusTab === 'rejected'"
              (bookmarkClick)="onBookmarkClick($event)"
              (pinClick)="onPinClick($event)"
              (editClick)="onEditClick($event)"
              (deleteClick)="onDeleteClick($event)"
            ></app-discussion-list>

            <app-discussion-pagination
              [currentPage]="currentPage"
              [totalPages]="totalPages"
              [visible]="discussions.length > 0"
              (pageChange)="onPageChange($event)"
            ></app-discussion-pagination>
          </div>
        </main>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <app-login-modal [(visible)]="showLoginModal"></app-login-modal>

  <app-confirmation-dialog
    [(visible)]="showEditConfirmModal"
    type="info"
    themeColor="green"
    title="Edit Discussion"
    [message]="discussionToEdit ? 'Edit &quot;' + (discussionToEdit.title || 'this discussion') + '&quot;? You will be taken to the edit form.' : ''"
    confirmLabel="Edit"
    cancelLabel="Cancel"
    (onConfirm)="onConfirmEdit()"
    (onCancel)="onCancelEdit()"
  ></app-confirmation-dialog>

  <app-confirmation-dialog
    [(visible)]="showDeleteConfirmModal"
    type="delete"
    themeColor="red"
    title="Delete Discussion"
    [message]="discussionToDelete ? 'Are you sure you want to delete &quot;' + (discussionToDelete.title || 'this discussion') + '&quot;? This action cannot be undone.' : ''"
    confirmLabel="Delete"
    cancelLabel="Cancel"
    [loading]="deleteInProgress"
    (onConfirm)="onConfirmDelete()"
    (onCancel)="onCancelDelete()"
  ></app-confirmation-dialog>
</div>
